import { Button, Upload, message } from "antd";
import React, { useState, useEffect } from "react";
import { File } from "../../models/File";
import { uploadFile } from "../../services/FileService";
import { RcFile } from "antd/es/upload";
import { UploadOutlined } from "@ant-design/icons";

const UploadImage = (props: any) => {
  const handleUpload = async (file: any, type: string) => {
    try {
      const response = await uploadFile(file.file);
      const uploadedPhotoWithBackend = response.data;

      props.allImageFunc(uploadedPhotoWithBackend, type);

      props.toast?.current?.show({
        severity: "success",
        detail: "Slika je uspešno uploadovana!",
        life: 3000,
      });
    } catch (error) {
      console.error(error);
      props.toast?.current?.show({
        severity: "error",
        detail: "Došlo je do greške prilikom uploada slike.",
        life: 3000,
      });
    }
  };

  const beforeUpload = (file: RcFile) => {
    // Provera tipa i veličine fajla pre slanja
    const allowedTypes = ["image/jpeg", "image/png"];
    const isAllowedType = allowedTypes.includes(file.type);
    const isAllowedSize = file.size / 1024 / 1024 < 50; // Maksimalna veličina 5MB

    if (!isAllowedType) {
      props.toast?.current?.show({
        severity: "error",
        detail: "Dozvoljeni formati slika su JPEG i PNG!",
        life: 3000,
      });
    }

    if (!isAllowedSize) {
      props.toast?.current?.show({
        severity: "error",
        detail: "Slika ne sme biti veća od 50MB!",
        life: 3000,
      });
    }

    return isAllowedType && isAllowedSize;
  };

  return (
    <Upload
      multiple
      beforeUpload={beforeUpload}
      accept="image/*"
      customRequest={(file) => {
        handleUpload(file, props.type);
      }}
      action=""
      listType="picture"
      className="upload"
      showUploadList={false}
    >
      <Button className="button-upload" icon={<UploadOutlined />}>
        Click to Upload
      </Button>
      <label
        className="text"
        style={{ fontSize: "12px", opacity: "0.5", marginBottom: "10px" }}
      >
        Preporučena rezolucija slika 640*640
      </label>
    </Upload>
  );
};

export default UploadImage;
